module.exports = __webpack_public_path__ + "fonts/sourcesansproextralightitalic.390f85ae.woff2";